<template>
	<div class="point-shop">
		<nav-header @getTelPhone="getTelPhone" @getSearch="getSearch"></nav-header>
		<cube-scroll ref="scroll" :data="item" :options="options" @pulling-down="onPullingDown" @pulling-up="onPullingUp"
		 class="page_scroll">
			<div class="point-list-wrap">
				<div class="indexBanner" v-if="swiperSlides.length">
					<div class="indexswipers">
						<swiper :options="swiperOption" ref="mySwiper" id="indexSwiper">
							<swiper-slide v-for="(slide,index) in swiperSlides" :key="index">
								<a class="swiper-img" :href="slide.img_skip">
									<img :src="slide.img" alt="">
								</a>

							</swiper-slide>
						</swiper>
						<div class="swiper-pagination" id="pagnation" slot="pagination"></div>
					</div>
					<div class="indexBanner-more">
						<swiper :options="swiperOptionMore" ref="mySwiperMore" id="indexSwiperMore">
							<swiper-slide v-for="(slide, index) in items" :key="index">
								<router-link :to="slide.url">
									<!-- :href= "slide.url" -->
									<a class="swiper-img" :style="'background-image: url('+ slide.image +')'">
										<h5>{{slide.title}}</h5>
										<!--                          <p>{{slide.subTitle}}</p>-->
									</a>
								</router-link>
							</swiper-slide>
						</swiper>
					</div>
				</div>
			</div>
			<div class="m-proz1">
				<div class="wp">

					<van-tabs v-model="active" title-active-color='#60B0E3' title-inactive-color='#666666' line-width='280px'
					 line-height='2px' @change='chagetab'>
            <van-tab title="积分商品">
              <ul class="ul-listz11">
                <li class="nodata" v-if="pointShopInfo.length == 0">
                  <p>暂时没有数据哦~</p>
                </li>
                <li v-for="(item, index) in pointShopInfo" :key="item.commodity_integral_id	">
                  <router-link :to="{ name: 'pointShopDetail', params: { pointshop_id: item.commodity_integral_id }}">
                    <div class="pic">
                      <img v-lazy="item.img" />
                    </div>
                    <div class="txt">
                      <h3>{{item.title}}</h3>
                      <p>{{item.money}}积分</p>
                      <!--											<span>￥255</span>-->
                    </div>
                  </router-link>
                </li>
              </ul>
            </van-tab>
						<van-tab title="推荐积分商品">
							<ul class="ul-listz11">
								<li class="nodata" v-if="tjpointShopInfo.length == 0">
									<p>暂时没有数据哦~</p>
								</li>
								<li v-for="(item, index) in tjpointShopInfo" :key="item.commodity_integral_id">
									<router-link :to="{ name: 'pointShopDetail', params: { pointshop_id: item.commodity_integral_id }}">
										<div class="pic">
											<img v-lazy="item.img" />
										</div>
										<div class="txt">
											<h3>{{item.title}}</h3>
											<p>{{item.money}}积分</p>
<!--											<span>￥255</span>-->
										</div>
									</router-link>
								</li>
							</ul>
						</van-tab>




					</van-tabs>

				</div>
			</div>
		</cube-scroll>
		<footer-bar :sy='3'></footer-bar>
	</div>
</template>
<script>
	import footerBar from '../components/footer'
	import navHeader from '../components/nav/nav'
	import Vue from 'vue'
	import {
		Toast
	} from 'vant'
	Vue.use(Toast)
	import {
		Tab,
		Tabs
	} from 'vant';
	Vue.use(Tab).use(Tabs);
	export default {
		name: 'pointShop',
		data() {
			return {
				active: 0,
				item: [],
				options: {
					pullUpLoad: {
						threshold: 60,
						txt: {
							more: '加载更多',
							// noMore: '没有更多了'
						}
					},
					pullDownRefresh: {
						threshold: 60,
						// stop:,
						// stopTime:,
						txt: '刷新成功'
					},
				},
				swiperOptionMore: {
					slidesPerView: '2.3',
					spaceBetween: 15,
				},
				items: [{
						image: require('../assets/images/yp1.jpg'),
						url: '/getPoint',
						title: '赚取积分',
						subTitle: '开启未来之门的金钥匙'
					},
					{
						image: require('../assets/images/yp2.jpg'),
						url: '/myPoint',
						title: '我的积分',
						subTitle: '生命的本源来源于基因'
					},
					{
						image: require('../assets/images/yp1.jpg'),
						url: '/myPoint',
						title: '兑换记录',
						subTitle: '开启未来之门的金钥匙'
					}
				],
				swiperOption: {
					notNextTick: true,
					//循环
					loop: true,
					spaceBetween: 10,
					//设定初始化时slide的索引
					initialSlide: 0,
					//自动播放
					autoplay: false,

					effect: 'slide',
					//滑动速度
					speed: 800,

					on: {
						slideChangeTransitionEnd: function() {}
					},

					//分页器设置
					pagination: {
						el: '.swiper-pagination',
						clickable: true

					}
				},
				swiperSlides: [],
				pointShopInfo: [],
				tjpointShopInfo: [],
				pageNum: 1,
				allpage: null,
				isSearch: false
			}
		},
		mounted() {

		},
		created() {
			this.loadPage(1, 1)
		},
		methods: {
			//切换tab
			chagetab(e) {
				var that = this;
				console.log(e);
				if (e == 0) {
					that.getjfgood('', 1)
				} else if (e ==1) {
					that.gettjjfgood('', 1,1)
				}
			},
			loadPage(pageNum, type) {
				let _this = this
				_this.$loading.show()
				_this.$http.api.bannerIndex({
					banner_type: 2
				}).then(result => {
					_this.$loading.hide()
					_this.swiperSlides = [...result]
				})
				if (_this.active == 0) {

          _this.getjfgood('', pageNum, type)
				} else {
					_this.gettjjfgood('', pageNum, type)
				}

			},
			//获取积分商品
			getjfgood(value, pageNum, type) {
				let _this = this;
				// 获取所有积分商品
				_this.$http.api.pointShop({
					page: pageNum,
					size: 10,
					status: 1,
					title: value
				}).then(result => {
					_this.allpage = Math.ceil(result.total / 10)
					// console.log(_this.allpage)
					let data = result.rows
					if (type === 1) {
						_this.pointShopInfo = [...data]
						_this.pageNum = 2
					} else {
						if (data.length > 0 && _this.pageNum <= _this.allpage) {
							_this.pointShopInfo = _this.pointShopInfo.concat(...data)
							_this.pageNum = _this.pageNum + 1
							_this.$refs.scroll.forceUpdate()
						}
					}
				})
				if (_this.pageNum > _this.allpage) {
					setTimeout(function() {
						_this.$refs.scroll.forceUpdate()
					}, 300)
				}
			},
			//推荐积分商品
			gettjjfgood(value, pageNum, type) {
				let _this = this;
				//推荐积分商品
				_this.$http.api.tjpointShop({
					page: pageNum,
					size: 10,
					user_id: localStorage.getItem('user_id'),
					title: value
				}).then(result => {
					_this.allpage = Math.ceil(result.total / 10)
					let data = result.rows
					if (type === 1) {
						_this.tjpointShopInfo = [...data]
						_this.pageNum = 2
					} else {
						if (data.length > 0 && _this.pageNum <= _this.allpage) {
							_this.tjpointShopInfo = _this.tjpointShopInfo.concat(...data)
							_this.pageNum = _this.pageNum + 1
							_this.$refs.scroll.forceUpdate()
						}
					}
				})
				if (_this.pageNum > _this.allpage) {
					setTimeout(function() {
						_this.$refs.scroll.forceUpdate()
					}, 300)
				}
			},
			onPullingDown() {
				this.active = 0
				if (this.isSearch) {
					this.getSearch(this.searchText, 1, 1)
				} else {
					this.loadPage(1, 1)
				}
			},
			onPullingUp() {
				let _this = this
				setTimeout(function() {
					if (_this.isSearch) {
						_this.getSearch(_this.searchText, _this.pageNum, 2)
					} else {
						_this.loadPage(_this.pageNum, 2)
					}

				}, 800)
			},
			//搜索
			getSearch(value, pageNum = 1, type = 1) {
				this.isSearch = true
				this.searchText = value
				let _this = this
				// 获取所有积分商品
				if (_this.active == 0) {
					_this.getjfgood(value, pageNum = 1, type = 1)
				} else {
					_this.gettjjfgood(value, pageNum = 1);
				}
			},
			getTelPhone() {
				// 点击电话弹窗
				this.$createDialog({
					type: 'confirm',
					title: '4006-878-036',
					confirmBtn: {
						text: '通话',
						active: true,
						disabled: false,
						href: 'tel:4006-878-036'
					},
					cancelBtn: {
						text: '取消',
						active: false,
						disabled: false,
						href: 'javascript:;'
					},
					onConfirm: () => {

					},
					onCancel: () => {

					}
				}).show()
			}
		},
		components: {
			footerBar,
			navHeader
		}
	}
</script>
<style>
	.point-shop .van-tabs__line {
		background-color: #60B0E3;
	}
</style>
<style lang="less" scoped>
	.page_scroll {
		top: 61px;
	}

	.ul-listz11 li .txt {
		height: auto;
	}

	.point-shop {

		.point-list-wrap {
			// height: 350px;
			position: relative;

			// top: 61px;
			.indexBanner {
				width: 100%;
				padding: 10px 15px 0;
				box-sizing: border-box;
				background: #fff;

				#indexSwiper {
					border-radius: 5px;
				}

				.swiper-pagination {
					position: static;
				}

				#pagnation {
					// margin-bottom: 7px;
				}

				#pagnation /deep/ .swiper-pagination-bullet {
					width: 5px;
					height: 5px;
					margin-right: 5px;
				}

				#pagnation /deep/ .swiper-pagination-bullet-active {
					width: 12px;
					height: 5px;
					background: rgba(96, 176, 227, 1);
					border-radius: 6px;
				}

				.indexswipers {
					.swiper-img {
						width: 100%;
						display: inline-block;

						img {
							height: 153px;
							display: inline-block
						}
					}
				}

				.indexBanner-more {
					padding: 15px 0;

					.swiper-img {
						width: 100%;
						height: 77px;
						display: block;
						border-radius: 5px;
						overflow: hidden;
						background: no-repeat center center;
						-webkit-background-size: cover;
						background-size: cover;
						color: #fff;
						font-size: 11px;
						padding: 11px 11px 5px;
						margin-right: 7px;

						h5 {
							font-weight: 400;
							line-height: 1.1;
							font-size: 16px;
							margin-bottom: 7px;
							white-space: nowrap;
							overflow: hidden;
							-ms-text-overflow: ellipsis;
							text-overflow: ellipsis;
						}

						p {}
					}
				}
			}
		}

		.m-proz1 {
			// position: relative;
			// top: 61px;
		}
	}

	.nodata {
		width: 100%;
		text-align: center;

		p {
			font-size: 14px;
			padding-top: 20px;
		}
	}
</style>
